export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";